import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-cream to-white pt-24">
      <SEO 
        title="Page Not Found | Master Jewelers GA"
        description="The page you're looking for doesn't exist. Visit our homepage to explore custom jewelry, while-you-wait repairs, and more services in Cumming and Alpharetta, GA."
        keywords="jewelry store Georgia, custom engagement rings, jewelry repair near me"
      />
      
      <div className="max-w-4xl mx-auto px-6 py-16 text-center">
        <div className="text-8xl text-gold-500 mb-8">♦</div>
        
        <h1 className="font-playfair text-5xl md:text-6xl text-charcoal mb-6">
          Page Not Found
        </h1>
        
        <div className="w-24 h-px bg-gradient-gold mx-auto mb-8"></div>
        
        <p className="font-cormorant text-xl text-charcoal/70 mb-8 max-w-2xl mx-auto">
          The page you're looking for doesn't exist, but we're here to help you find exactly what you need.
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          <Link 
            to="/" 
            className="p-6 border-2 border-gold-400/20 hover:border-gold-400 rounded-lg transition-all duration-300 group"
          >
            <div className="text-3xl mb-4 group-hover:scale-110 transition-transform duration-300">🏠</div>
            <h3 className="font-playfair text-xl text-charcoal mb-2">Visit Our Homepage</h3>
            <p className="font-montserrat text-charcoal/60 text-sm">Explore our services and collections</p>
          </Link>
          
          <Link 
            to="/repair-estimate" 
            className="p-6 border-2 border-gold-400/20 hover:border-gold-400 rounded-lg transition-all duration-300 group"
          >
            <div className="text-3xl mb-4 group-hover:scale-110 transition-transform duration-300">🔧</div>
            <h3 className="font-playfair text-xl text-charcoal mb-2">Repair Calculator</h3>
            <p className="font-montserrat text-charcoal/60 text-sm">Get instant repair estimates</p>
          </Link>
          
          <div className="p-6 border-2 border-gold-400/20 hover:border-gold-400 rounded-lg transition-all duration-300 group">
            <div className="text-3xl mb-4 group-hover:scale-110 transition-transform duration-300">📞</div>
            <h3 className="font-playfair text-xl text-charcoal mb-2">Contact Us</h3>
            <p className="font-montserrat text-charcoal/60 text-sm">Cumming: (943) 221-6631</p>
            <p className="font-montserrat text-charcoal/60 text-sm">Alpharetta: (770) 410-1119</p>
          </div>
        </div>
        
        <Link 
          to="/" 
          className="inline-block px-8 py-4 bg-gradient-gold text-white font-montserrat text-sm tracking-wider hover:scale-105 transition-transform duration-300"
        >
          RETURN HOME
        </Link>
        
        <div className="mt-12 p-6 bg-gold-50 rounded-lg">
          <h3 className="font-playfair text-2xl text-charcoal mb-4">Popular Searches</h3>
          <div className="flex flex-wrap justify-center gap-4 text-sm">
            <span className="font-montserrat text-charcoal/70">Engagement Rings</span>
            <span className="font-montserrat text-charcoal/70">•</span>
            <span className="font-montserrat text-charcoal/70">Ring Sizing</span>
            <span className="font-montserrat text-charcoal/70">•</span>
            <span className="font-montserrat text-charcoal/70">Watch Repair</span>
            <span className="font-montserrat text-charcoal/70">•</span>
            <span className="font-montserrat text-charcoal/70">Jewelry Cleaning</span>
            <span className="font-montserrat text-charcoal/70">•</span>
            <span className="font-montserrat text-charcoal/70">Custom Design</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
